import moment from 'moment'
export function timeFix () {
  const time = new Date()
  const hour = time.getHours()
  return hour < 9 ? '早上好' : hour <= 11 ? '上午好' : hour <= 13 ? '中午好' : hour < 20 ? '下午好' : '晚上好'
}

export function welcome () {
  const arr = ['休息一会儿吧', '准备吃什么呢?', '要不要打一把 DOTA', '我猜你可能累了']
  const index = Math.floor(Math.random() * arr.length)
  return arr[index]
}

/**
 * 触发 window.resize
 */
export function triggerWindowResizeEvent () {
  const event = document.createEvent('HTMLEvents')
  event.initEvent('resize', true, true)
  event.eventType = 'message'
  window.dispatchEvent(event)
}

export function handleScrollHeader (callback) {
  let timer = 0

  let beforeScrollTop = window.pageYOffset
  callback = callback || function () {}
  window.addEventListener(
    'scroll',
    event => {
      clearTimeout(timer)
      timer = setTimeout(() => {
        let direction = 'up'
        const afterScrollTop = window.pageYOffset
        const delta = afterScrollTop - beforeScrollTop
        if (delta === 0) {
          return false
        }
        direction = delta > 0 ? 'down' : 'up'
        callback(direction)
        beforeScrollTop = afterScrollTop
      }, 50)
    },
    false
  )
}

/**
 * Remove loading animate
 * @param id parent element id or class
 * @param timeout
 */
export function removeLoadingAnimate (id = '', timeout = 1500) {
  if (id === '') {
    return
  }
  setTimeout(() => {
    document.body.removeChild(document.getElementById(id))
  }, timeout)
}


export default {
  formatDate(date){
    if(date == '~'){return date}
    return moment(date).format("YYYY-MM-DD")
  },
  format(date,format){
    if(date == '~'){return date}
    return moment(date).format(format)
  },
  getDealTypeIconNoBackground(dealType){ //获取交易类型图标
    let result = {type:'',style:''};
    switch(dealType){
      // case '':
      //   result.type = 'icon-zixun'
      //   result.style= 'font-size: 45px;'
      //   break
      case '新设立':
        result.type = 'icon-xinshelicopy_no'
        result.style= 'background: rgba(233, 94, 139, 0.2);'
        break
      case '搬迁':
        result.type = 'icon-banqiancopy_no'
        result.style= 'background-color: #E3E3E3;'
        break
      case '续租':
        result.type = 'icon-xuzucopy_no'
        result.style= 'background-color: #EEF5FC;'
        break
      case '租约重构':
        result.type = 'icon-zuyuezhonggoucopy_no'
        result.style= 'background-color: #DFF5EB;'
        break
      case '扩租':
        result.type = 'icon-kuozucopy_no'
        result.style= 'background-color: #F5ECDF;'
        break
      case '项目咨询与顾问':
        result.type = 'icon-zixunyufuwucopy_no'
        result.style= 'font-size: 16px;background-color: #E3E3E3;'
        break
      case '投资':
        result.type = 'icon-touzicopy_no'
        result.style= 'font-size: 16px;background: rgba(233, 94, 139, 0.2);'
        break
      case '其他或无需求':
        result.type = 'icon-qitacopy2_no'
        // result.style= 'font-size: 16px;background: #EEF5FC;'
        break
      default:
        break
    }
    return result
  },

  //获取追踪类型图标
  getTrackingIcon(dealType){
    let result = {type:'',style:''};
    switch (dealType) {
      case 1:
        result.type = 'icon-shoufengchuji'
        break
      case 2:
        result.type = 'icon-chuangzaoxuqiu'
        break
      case 3:
        result.type = 'icon-shibiexuqiu'
        break
      default:
        break
    }
    console.log('result',dealType)
    result.style += 'height: 45px; width: 45px; borderRadius: 50%;display: flex; justifyContent:center; alignItems: center;margin-right: 5px;font-size:35px;'
    return result
  },


  getDealTypeIcon(dealType){ //获取交易类型图标
    let result = {type:'',style:''};
    switch(dealType){
      // case '':
      //   result.type = 'icon-zixun'
      //   result.style= 'font-size: 45px;'
      //   break
      case '新设立':
        result.type = 'icon-xinshelicopy'
        // result.style= 'background: rgba(233, 94, 139, 0.2);'
        break
      case '购买':
        result.type = 'icon-wuyegoumai1'
        break
      case '搬迁':
        result.type = 'icon-banqiancopy'
        // result.style= 'background-color: #E3E3E3;'
        break
      case '续租':
        result.type = 'icon-xuzucopy'
        // result.style= 'background-color: #EEF5FC;'
        break
      case '租约重构':
        result.type = 'icon-zuyuezhonggoucopy'
        // result.style= 'background-color: #DFF5EB;'
        break
      case '扩租':
        result.type = 'icon-kuozucopy'
        // result.style= 'background-color: #F5ECDF;'
        break
      case '项目咨询与顾问':
        result.type = 'icon-zixunyufuwucopy'
        // result.style= 'font-size: 16px;background-color: #E3E3E3;'
        break
      case '投资':
        result.type = 'icon-touzicopy'
        // result.style= 'font-size: 16px;background: rgba(233, 94, 139, 0.2);'
        break
      case '其他或无需求':
        result.type = 'icon-qitacopy2'
        // result.style= 'font-size: 16px;background: #EEF5FC;'
        break
      case '其他':
        result.type = 'icon-qitacopy2'
        // result.style= 'font-size: 16px;background: #EEF5FC;'
        break
      default:
        break
    }
    result.style += 'height: 45px; width: 45px; borderRadius: 50%;display: flex; justifyContent:center; alignItems: center;margin-right: 5px;font-size:35px;'
    return result
  },
  getNowFormatDate:function () { //获取当前时间年月日
    var date = new Date();
    var seperator1 = "-";
    var year = date.getFullYear();
    var month = date.getMonth() + 1;
    var strDate = date.getDate();
    if (month >= 1 && month <= 9) {
      month = "0" + month;
    }
    if (strDate >= 0 && strDate <= 9) {
      strDate = "0" + strDate;
    }
    var currentdate = year + seperator1 + month + seperator1 + strDate;
    return currentdate;
  },
  getPassYearFormatDate:function () { //获取过去一年的时间
    var nowDate = new Date();
    var date = new Date(nowDate);
    date.setDate(date.getDate()-365);
    var seperator1 = "-";
    var year = date.getFullYear();
    var month = date.getMonth() + 1;
    var strDate = date.getDate();
    if (month >= 1 && month <= 9) {
      month = "0" + month;
    }
    if (strDate >= 0 && strDate <= 9) {
      strDate = "0" + strDate;
    }
    var currentdate = year + seperator1 + month + seperator1 + strDate;
    return currentdate;
  },
  getMonthBetween:function(start,end){
    var sdate = start, edate = end;
    var syear = parseInt(sdate.split('-')[0], 10), smonth = parseInt(sdate.split('-')[1], 10);
    var eyear = parseInt(edate.split('-')[0], 10), emonth = parseInt(edate.split('-')[1], 10);
    var result = [];
    while((syear * 12 + smonth) <= (eyear * 12 + emonth)){
      if(smonth < 10){
        result.push(syear+'-0'+smonth);
      }else{
        result.push(syear+'-'+smonth);
      }
      if(++smonth > 12){
        syear++;
        smonth = 1;
      }
    }
    return result;
  },
  commafyback:function (num) {//去除千分位
    if(num.toString().indexOf(",")> -1){
      var x = ''+num.replace(/,/g,"");
      return parseFloat(x);
    }else{
      return num
    }

  },
  numberFormat(value) {
    if (!value) {
      return '0.00'
    }
    let intPartFormat = "0"
    if(typeof value == "string"){
      intPartFormat = value.toString().replace(/(\d)(?=(\d{3})+\.)/g, '$&,')//浮点数
    }else{
      if(value % 1 === 0){
        intPartFormat = parseFloat(value).toFixed(2).toString().replace(/(\d)(?=(\d{3})+\.)/g, '$1,') // 将整数部分逢三一断
      }else{
        intPartFormat = parseFloat(value).toFixed(2).toString().replace(/(\d)(?=(\d{3})+\.)/g, '$&,')//浮点数
      }
    }
    return intPartFormat
  }
}
